import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { EnumButtonSizes }		from '@/enums/enums';
import { useCampaignStore }		from '@/stores/campaignStore';
import { usePagesUtilStore }	from '@/stores/pagesUtilStore';
import { useAuthStore }				from '@/stores/authStore'
import messages               from '@/utils/messages';
import { CONST_CAMPAIGN_STATUS }   from '@/static/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnPublishFocusedCampaign',
  setup(__props) {

const campaignStore		= useCampaignStore();
const pagesUtilStore	= usePagesUtilStore();
const authStore 			= useAuthStore();

const onPublishFocusedCampaignBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true;
  
   	await campaignStore.publishFocusedCampaign();
		
		messages.showSuccessMsg("Campanha publicada com sucesso!");

  } catch (errorApprovingCampaign) {
    messages.showErrorMsg("Erro ao tentar publicar a campanha...");
  
  } finally {
    pagesUtilStore.showLoading = false;
  }
};


const onRepublishFocusedCampaignBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true;
  
   	await campaignStore.republishFocusedCampaign();
		
		messages.showSuccessMsg("Campanha republicada com sucesso!");

  } catch (errorApprovingCampaign) {
    messages.showErrorMsg("Erro ao tentar republicar a campanha...");
  
  } finally {
    pagesUtilStore.showLoading = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authStore).currentUserCanPublishCampaign 
		&& _unref(campaignStore).focusedCampaign.status == _unref(CONST_CAMPAIGN_STATUS).APPROVED.id)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 0,
          id: "btn-publish-campaign",
          propBtnLabel: "Publicar Campanha",
          propBtnFunction: onPublishFocusedCampaignBtnClick,
          propBtnTransparent: false,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true),
    (_unref(authStore).currentUserCanPublishCampaign 
		&& _unref(campaignStore).focusedCampaign.status == _unref(CONST_CAMPAIGN_STATUS).REAPPROVED.id)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 1,
          id: "btn-publish-campaign",
          propBtnLabel: "Republicar Campanha",
          propBtnFunction: onRepublishFocusedCampaignBtnClick,
          propBtnTransparent: false,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})